var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechniusSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5035 45C10.0968 45.0017 0.00173956 34.9101 2.24841e-07 22.5035C-0.00173911 10.0968 10.0881 0.00173956 22.4948 2.24841e-07C34.9014 -0.00173911 44.9965 10.0881 44.9983 22.4948C45 34.9014 34.9101 44.9965 22.5035 44.9983V45ZM22.4948 1.76542C11.0622 1.76716 1.76194 11.0708 1.76368 22.5052C1.76542 33.9378 11.0691 43.2381 22.5035 43.2363C33.9361 43.2346 43.2363 33.9309 43.2346 22.4965C43.2328 11.0639 33.9291 1.76368 22.4948 1.76542Z",
    fill: "url(#paint0_linear_747_949)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1508 22.3031L14.6469 11.8027L10.1664 11.8045L20.6702 22.3031L10.0812 32.8974L10.1629 32.9808L14.4782 32.9791L25.1508 22.3031Z",
    fill: "url(#paint1_linear_747_949)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1343 22.1078L22.5452 32.702L22.6287 32.7838H26.9423L37.6148 22.1078L27.111 11.6074L22.6305 11.6092L33.1343 22.1078Z",
    fill: "url(#paint2_linear_747_949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_747_949",
    x1: 40.9056,
    y1: 8.43402,
    x2: 5.16408,
    y2: 35.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_747_949",
    x1: 17.8751,
    y1: 15.3962,
    x2: 15.9219,
    y2: 30.3388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_747_949",
    x1: 29.273,
    y1: 21.3059,
    x2: 31.2506,
    y2: 36.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C50C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3161AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechniusSymbol);
export default __webpack_public_path__ + "static/media/TechniusSymbol.8dcfd8c10f3f67ffd37bc16ceb52027b.svg";
export { ForwardRef as ReactComponent };